module.exports = __webpack_public_path__ + "img/button.a36a11a6.png";